import { Button, Empty, Input, Tabs } from 'antd'
import pickBy from 'lodash/pickBy'
import { inject, observer } from 'mobx-react'
import moment from 'moment'
import queryString from 'query-string'
import React, { useEffect, useMemo } from 'react'
import { Helmet } from 'react-helmet/es/Helmet'
import { useLocation } from 'react-router-dom'
import AccessControlAction from '../../../../components/AccessControlAction'
import {
  AddCircleOutlineIcon,
  MagnifierOutlineIcon,
} from '../../../../components/AppIcon'
import { AppTable } from '../../../../components/AppTable/AppTable'
import { AppTablePagination } from '../../../../components/AppTable/AppTablePagination'
import { AvatarHasName } from '../../../../components/Common/Avatar'
import { EmptyText, Text } from '../../../../components/Common/CellText'
import { StatusTag } from '../../../../components/Common/StatusTag'
import ContentBlockWrapper from '../../../../components/ContentBlockWrapper'
import {
  ACL_ACTION_TYPE,
  ASSIGNEE_TYPE,
  PROPOSAL_TYPE,
  TYPE_STATUS,
} from '../../../../constants'
import DashboardLayout from '../../../../layouts/DashboardLayout'
import AppPageHeader from '../../../../components/AppPageHeader'
import ProposalPageAdvanceFilterV2 from './ProposalPageAdvanceFilterV2'
import { IssueInfo } from './ProposalPageStyled'
import utils from '../../../../utils'
const { TabPane } = Tabs
export const submissionMenu = [
  {
    id_group: '1',
    name_group: 'Hành chính - Nhân sự',
    child: [
      {
        id_child: 'BUSINESS_TRIP',
        name_child: PROPOSAL_TYPE.BUSINESS_TRIP.label,
      },
      { id_child: 'LEAVE', name_child: PROPOSAL_TYPE.LEAVE.label },
      {
        id_child: 'LEAVE_ABNORMAL',
        name_child: PROPOSAL_TYPE.LEAVE_ABNORMAL.label,
      },
      {
        id_child: 'LEAVE_NO_SALARY',
        name_child: PROPOSAL_TYPE.LEAVE_NO_SALARY.label,
      },
      {
        id_child: 'LEAVE_ANNUAL',
        name_child: PROPOSAL_TYPE.LEAVE_ANNUAL.label,
      },
      { id_child: 'SICK', name_child: PROPOSAL_TYPE.SICK.label },
      { id_child: 'SICK_OTHER', name_child: PROPOSAL_TYPE.SICK_OTHER.label },
      {
        id_child: 'OVERTIME_NORMAL',
        name_child: PROPOSAL_TYPE.OVERTIME_NORMAL.label,
      },
      {
        id_child: 'OVERTIME_DAYOFF',
        name_child: PROPOSAL_TYPE.OVERTIME_DAYOFF.label,
      },
      {
        id_child: 'OVERTIME_HOLIDAY',
        name_child: PROPOSAL_TYPE.OVERTIME_HOLIDAY.label,
      },
      // {
      //   id_child: 'OVERTIME_CHAIRMAN',
      //   name_child: PROPOSAL_TYPE.OVERTIME_CHAIRMAN.label,
      // },
      {
        id_child: 'RETIMEKEEPING',
        name_child: PROPOSAL_TYPE.RETIMEKEEPING.label,
      },
    ],
  },
  {
    id_group: '2',
    name_group: 'Hành chính - Văn phòng',
    child: [
      {
        id_child: 'EVALUATE_MEMBER',
        name_child: PROPOSAL_TYPE.EVALUATE_MEMBER.label,
      },
      {
        id_child: 'EVALUATE_LEADER',
        name_child: PROPOSAL_TYPE.EVALUATE_LEADER.label,
      },
      { id_child: 'TIMEKEEPER', name_child: PROPOSAL_TYPE.TIMEKEEPER.label },
      { id_child: 'STATIONERY', name_child: PROPOSAL_TYPE.STATIONERY.label },
      { id_child: 'MEETING', name_child: PROPOSAL_TYPE.MEETING.label },
      { id_child: 'VEHICLE', name_child: PROPOSAL_TYPE.VEHICLE.label },
    ],
  },
]

const ProposalPage = props => {
  const { history, proposalStore, loadingAnimationStore } = props
  const { proposalList, totalCountProposal } = proposalStore

  const location = useLocation()
  const queryStringParse = useMemo(
    () =>
      queryString.parse(location.search, {
        arrayFormat: 'index',
      }),
    [location.search]
  )

  /** Columns table */
  const tableColumns = useMemo(
    () => [
      {
        title: 'Loại',
        width: 200,
        ellipsis: true,
        render: record =>
          record?.proposal_type_name || (
            <EmptyText>Không có Loại công việc.</EmptyText>
          ),
      },
      {
        title: 'Tiêu đề',
        width: 350,
        ellipsis: true,
        render: record =>
          record?.title || <EmptyText>Không có tiêu đề.</EmptyText>,
      },
      {
        title: 'Ngày tạo',
        width: 180,
        render: record => (
          <Text>{moment(record?.created_at).format('DD/MM/YYYY')}</Text>
        ),
      },
      {
        title: 'Người gửi',
        width: 200,
        ellipsis: true,
        render: record =>
          utils.getNameInCapitalize(record?.create_user?.name_lowercase),
      },
      {
        title: 'Trạng thái',
        width: 150,
        align: 'center',
        render: record =>
          record.proposal_type_is_deleted ? (
            <IssueInfo>
              {StatusTag(
                TYPE_STATUS.PROPOSAL_TYPE,
                record.proposal_type_is_deleted
              )}
            </IssueInfo>
          ) : (
            <IssueInfo>
              {StatusTag(TYPE_STATUS.PROPOSAL, record.proposal_status)}
            </IssueInfo>
          ),
      },
    ],
    []
  )

  /** Search, filter phiếu trình */
  const onSearchProposal = values => {
    const queryStringStringify = queryString.stringify(
      {
        ...queryStringParse,
        keyword: values?.trim() || null,
        page: 0,
        size: queryStringParse?.size || 10,
      },
      {
        skipNull: true,
      }
    )
    history.push(`/proposal?${queryStringStringify}`)
  }

  const handleFilterProposalPermission = value => {
    const queryStringStringify = queryString.stringify(
      {
        proposal_permission: value || null,
        page: 0,
        size: queryStringParse?.size || 10,
      },
      {
        skipNull: true,
      }
    )
    history.push(`/proposal?${queryStringStringify}`)
  }

  const handleChangePageProposalLeave = (page, pageSize) => {
    const queryStringStringify = queryString.stringify(
      {
        ...queryStringParse,
        page: page - 1,
        size: pageSize,
      },
      {
        skipNull: true,
      }
    )
    history.push(`/proposal?${queryStringStringify}`)
  }

  /** Tab */
  const tabKeys = [
    '',
    ASSIGNEE_TYPE.CREATE,
    ASSIGNEE_TYPE.HANDLER,
    ASSIGNEE_TYPE.FOLLOWER,
  ]
  const tabName = tabKey => {
    switch (tabKey) {
      case '':
        return 'Tất cả'
      case ASSIGNEE_TYPE.CREATE:
        return 'Đã gửi'
      case ASSIGNEE_TYPE.HANDLER:
        return 'Xử lý'
      case ASSIGNEE_TYPE.FOLLOWER:
        return 'Theo dõi'
      case ASSIGNEE_TYPE.COMBINER:
        return 'Phối hợp'
      default:
        return ''
    }
  }

  const loadProposalsList = async () => {
    const queryParams = {
      page: queryStringParse?.page || 0,
      size: queryStringParse?.size || 10,
      proposal_permission: queryStringParse?.proposal_permission,
      keyword: queryStringParse?.keyword || null,
      proposal_status: queryStringParse?.proposal_status,
      created_at: queryStringParse?.created_at,
      type: queryStringParse?.type,
      create_user: queryStringParse?.create_user,
      from_date: queryStringParse?.from_date,
      to_date: queryStringParse?.to_date,
    }
    try {
      loadingAnimationStore.setTableLoading(true)
      const formattedQueryPayload = pickBy(queryParams, v => v != null)
      await proposalStore.getProposalsV2(formattedQueryPayload)
    } catch (error) {
      loadingAnimationStore.setTableLoading(false)
      console.log(error)
    } finally {
      loadingAnimationStore.setTableLoading(false)
    }
  }

  useEffect(() => {
    try {
      // proposalStore.setFilter(
      //   'pageIndex',
      //   queryStringParse.page ? parseInt(queryStringParse?.page) : 0
      // )
      // proposalStore.setFilter(
      //   'pageSize',
      //   queryStringParse.page ? parseInt(queryStringParse?.size) : 10
      // )
      // proposalStore.setFilter(
      //   'proposalPermission',
      //   queryStringParse.proposal_permission
      // )
      // proposalStore.setFilter('keyword', queryStringParse.keyword)
      // proposalStore.setFilter(
      //   'proposalStatus',
      //   queryStringParse.proposal_status
      // )
      // proposalStore.setFilter('createdAt', queryStringParse.created_at)
      // proposalStore.setFilter('type', queryStringParse.type)
      // proposalStore.setFilter('createUser', queryStringParse.create_user)
      // proposalStore.setFilter('fromDate', queryStringParse.from_date)
      // proposalStore.setFilter('toDate', queryStringParse.to_date)

      void loadProposalsList()
    } catch (error) {
      console.log(error)
    }

    // return () => {
    //   proposalStore.clearFilterProposal()
    // }
  }, [queryStringParse])

  return (
    <DashboardLayout>
      <Helmet>
        <title>Hành chính | Danh sách thủ tục hành chính</title>
      </Helmet>
      <AppPageHeader
        title="Danh sách việc hành chính"
        addon={
          <>
            <Input.Search
              allowClear
              onSearch={onSearchProposal}
              defaultValue={queryStringParse?.keyword}
              maxLength={500}
              placeholder="Tìm kiếm theo tiêu đề"
              enterButton={
                <MagnifierOutlineIcon
                  style={{ color: '#000', width: 16, height: 16 }}
                />
              }
              className="custom-search-input fixed-width"
            />
            <ProposalPageAdvanceFilterV2 />
            <AccessControlAction aclActionType={ACL_ACTION_TYPE.create__PROPOSAL}>
              <Button
                icon={
                  <AddCircleOutlineIcon
                    style={{ color: '#fff', width: 16, height: 16 }}
                  />
                }
                onClick={() => history.push('/proposal/create')}
                type={'primary'}
                className="custom-ant-button icon-btn">
                Tạo mới
              </Button>
            </AccessControlAction>
          </>
        }
      />

      <Tabs
        defaultActiveKey={queryStringParse.proposal_permission || ''}
        onChange={handleFilterProposalPermission}>
        {tabKeys.map((tabKey, index) => {
          return (
            <TabPane tab={tabName(tabKey)} key={tabKey}>
              <AppTable
                // rowSelection={rowSelection}
                onRow={record => {
                  return {
                    onClick: () =>
                      history.push(
                        `/proposal/other/view/${record.proposal_code}`
                      ),
                  }
                }}
                rowKey={record => record.proposal_code}
                dataSource={proposalList}
                columns={tableColumns}
                pagination={false}
                locale={{
                  emptyText: (
                    <Empty
                      image={Empty.PRESENTED_IMAGE_SIMPLE}
                      description={'Không có dữ liệu'}
                    />
                  ),
                }}
                loading={loadingAnimationStore.tableLoading}
              />

              <AppTablePagination
                onChange={handleChangePageProposalLeave}
                total={totalCountProposal}
                current={Number(queryStringParse?.page || 0) + 1}
                pageSize={Number(queryStringParse?.size || 10)}
              />
            </TabPane>
          )
        })}
      </Tabs>
    </DashboardLayout>
  )
}

// ProposalPage.propTypes = {
//   proposalStore: PropTypes.object,
// }

export default inject(
  'proposalStore',
  'loadingAnimationStore',
  'selectPeopleStore',
  'proposalTypeStore'
)(observer(ProposalPage))
